export default {"src":"/_next/static/media/kesspay_credit.09a9df45.svg","height":22,"width":67,"blurWidth":0,"blurHeight":0};